import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faPencil } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Checkbox, Grid, HoverHintWrapper, Link, Text,
} from '@domain-group/suit-theme'

import useCampaignQuoteItem from '@hooks/useCampaignQuoteItem'
import type { InvalidPrice } from '@hooks/useCampaignQuote'

interface InvalidPricesListItemProps {
  callbacks: {
    toggleId: (id: number) => void,
    validateFn: () => void,
  },
  checked: boolean,
  invalidPrice: InvalidPrice,
  lastItem: boolean,
}

const InvalidPricesListItem = (props: InvalidPricesListItemProps) => {
  const {
    callbacks: { toggleId, validateFn }, checked, invalidPrice, lastItem,
  } = props

  const {
    current_price, display_title, original_price, campaign_quote_item_id,
  } = invalidPrice || {}

  const campaignQuoteItemPayload = useCampaignQuoteItem({ id: campaign_quote_item_id })
  const {
    callbacks: {
      editQuantityAndOptions,
    },
  } = campaignQuoteItemPayload

  const currentPriceIsZero = current_price === 0

  return (
    <Grid
      // @ts-expect-error TS2322
      gridTemplateColumns="28px minmax(80px,5fr) minmax(80px,1fr) minmax(80px,1fr) minmax(18px,32px) minmax(18px,32px)"
      alignItems="center"
      fontSize="small"
      paddingY="medium"
      borderBottom={lastItem ? 'none' : '1px dashed'}
      borderColor="lineColor"
    >
      <Checkbox
        checked={checked}
        style={{
          cursor: currentPriceIsZero ? 'default' : 'pointer',
          opacity: currentPriceIsZero ? 0.5 : 1,
        }}
        onClick={currentPriceIsZero ? undefined : toggleId}
      />

      <Text variant="ellipsis">{display_title}</Text>

      <Text textAlign="right">${original_price}</Text>

      <Text textAlign="right">${current_price}</Text>

      <Box textAlign="center">
        {currentPriceIsZero && (
          <HoverHintWrapper
            boxProps={{ height: 'fit-content', marginLeft: 'small' }}
            hintComponent={(
              <HoverHintWrapper.Hint
                boxProps={{ position: 'absolute', right: 0, padding: 'large' }}
              >
                <Text textAlign="left" color="faintGrey" fontSize="small">
                  This quantity or option may not be available on current price list.
                </Text>
              </HoverHintWrapper.Hint>
            )}
          >
            <FontAwesomeIcon icon={faExclamationCircle} style={{ color: 'orange' }} />
          </HoverHintWrapper>
        )}
      </Box>

      <Box textAlign="center">
        <Link
          greyLink
          onClick={() => editQuantityAndOptions({ modalSize: 'large', validateFn })}
          textProps={{ marginLeft: 'medium' }}
        >
          <FontAwesomeIcon icon={faPencil} />
        </Link>
      </Box>
    </Grid>
  )
}

export default InvalidPricesListItem
